var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAparat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 951,
    height: 903,
    viewBox: "0 0 951 903",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M933.8 841.4C933.8 865.8 913.9 885.7 889.5 885.7H61.4C37 885.7 17.1 865.8 17.1 841.4V287.6C17.1 263.2 37 243.3 61.4 243.3H889.7C914.1 243.3 934 263.2 934 287.6V841.4H933.8Z",
    stroke: "white",
    strokeWidth: 33.8391,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M475.5 766.6C587.117 766.6 677.6 676.117 677.6 564.5C677.6 452.883 587.117 362.4 475.5 362.4C363.883 362.4 273.4 452.883 273.4 564.5C273.4 676.117 363.883 766.6 475.5 766.6Z",
    stroke: "white",
    strokeWidth: 36.442,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M511.9 588.6C537.305 588.6 557.9 568.005 557.9 542.6C557.9 517.195 537.305 496.6 511.9 496.6C486.495 496.6 465.9 517.195 465.9 542.6C465.9 568.005 486.495 588.6 511.9 588.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M574.8 503.9C589.933 503.9 602.2 491.633 602.2 476.5C602.2 461.367 589.933 449.1 574.8 449.1C559.667 449.1 547.4 461.367 547.4 476.5C547.4 491.633 559.667 503.9 574.8 503.9Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M621.2 62.2C613.5 37.7 586.1 17.5 560.2 17.5H394.1C368.4 17.5 340.6 37.4 332.5 62L288 197.2C279.9 221.7 294.3 241.7 320.2 241.7H631C656.7 241.7 671.5 221.6 663.8 197L621.2 62.2Z",
    stroke: "white",
    strokeWidth: 34.1862,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M557.1 77.6001H393.9V139H557.1V77.6001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAparat);
export default __webpack_public_path__ + "static/media/aparat.e29b890abc6c3d929e66815950fe6b38.svg";
export { ForwardRef as ReactComponent };